import jsCookie from 'js-cookie';

const cookies = {
  set(key, value, expires = { expires: 3 }) {
    let res = '';
    try {
      res = typeof value == 'object' ? JSON.stringify(value) : value;
      jsCookie.set(key, res, expires);
    } catch (err) {
      console.log(err);
    }
  },
  get(key) {
    let res = jsCookie.get(key);
    try {
      res = JSON.parse(res);
      if (typeof res === 'number') {
        return jsCookie.get(key);
      }
    } catch {
    
    }
    
    return res;
  },
  remove(key) {
    return jsCookie.remove(key);
  },
  setToken(token) {
    return jsCookie.set('SECVALUE', token);
  },
  getToken() {
    return jsCookie.get('SECVALUE');
  },
  getUserInfo() {
    return cookies.get('mall-userInfo') || {};
  },
  getAgentInfo() {
    return cookies.get('agentInfo') || {};
  },
  logout() {
    cookies.remove('SECVALUE');
    cookies.remove('mall-userInfo');
  }
};

export default cookies;
